MotifsDepreciationStockController.$inject = [
	'$scope',
	'$state',
	'$stateParams',
	'$translate',
	'ModalService',
	'PaginationService',
	'MotifsDepreciationStockService',
	'notification',
	'$transitions'
];

// Du fait d'une limitation d'angularJS et de blocks.smart.table
// le controller doit être déclaré comme une fonction et non une classe
// on injecte donc directement les dépendances dans la fonction comme le veut angularJS
export default function MotifsDepreciationStockController(
	$scope,
	$state,
	$stateParams,
	$translate,
	ModalService,
	PaginationService,
	MotifsDepreciationStockService,
	notification,
	$transitions
) {
	const vm = this;
	const watchers = [];

	let previousTableState;
	let selectedMotifDepreciationStockId = undefined;

	vm.loading = false;
	vm.stateParams = $stateParams;
	vm.motifsDepreciationStock = [];

	vm.slideWidth = '500px';
	vm.slideMargin = {
		'margin-right': '0px',
		'transition-duration': '0.5s',
		'transition-animation': 'margin-right',
		height: '100%'
	};
	vm.itemsByPageOptions = [20, 100, 200];
	vm.itemsByPage = vm.itemsByPageOptions[0];

	vm.isMotifDepreciationStockSelected = isMotifDepreciationStockSelected;
	vm.loadMotifsDepreciationStock = loadMotifsDepreciationStock;
	vm.deleteMotifDepreciationStock = deleteMotifDepreciationStock;

	function init() {
		//écouter l'event lié au changement de route
		//une fois on change l'url, et on arrive sur la page "motifs.list", on désélectionne la ligne sélectionnée (s'il y en a)
		$transitions.onSuccess({}, stateChangeSuccessFunc);
		//$transitions.onSuccess({}, stateChangeSuccessFunc);
		watchers.push($scope.$on('$destroy', dispose));
	}

	init();

	function stateChangeSuccessFunc(event, toState) {
		if (!$stateParams) {
			selectedMotifDepreciationStockId = undefined;
		}
	}

	function isMotifDepreciationStockSelected(motifDepreciationStock) {
		return motifDepreciationStock && motifDepreciationStock.id && selectedMotifDepreciationStockId === motifDepreciationStock.id;
	}

	async function loadMotifsDepreciationStock(tableState) {
		startLoading();

		//quand on rafraîchit la grille, on revient sur "motifs.list", et on ferme la vue détail d'un motif
		//sinon, on risque d'avoir la vue détail qui est ouverte, mais la ligne n'apparaît plus dans la grille
		if ($state && $state.current && $state.current.name !== 'motifs-depreciation-stock.list') {
			$state.go('motifs-depreciation-stock.list');
		}

		if (tableState) {
			previousTableState = tableState;
		}

		const filters = PaginationService.getFilters(previousTableState);
		const sorts = PaginationService.getSorts(previousTableState);
		const pagination = PaginationService.getPagination(previousTableState);

		vm.motifsDepreciationStock = [];

		try {
			const data = await MotifsDepreciationStockService.getMotifsDepreciationStock(filters, sorts, pagination);
			vm.motifsDepreciationStock = data.items;

			if (previousTableState) {
				PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
			}
		} catch (ex) {
			notification.error(ex.data);
		} finally {
			stopLoading();
		}
	}

	async function deleteMotifDepreciationStock(motifDepreciationStock) {
		if (motifDepreciationStock && motifDepreciationStock.id) {
			const modalInstance = ModalService.confirm({
				modalTitle: $translate.instant('MOTIFS_DEPRECIATION_STOCK.DELETE.TITLE', { libelle: motifDepreciationStock.libelle }),
				modalMsg: $translate.instant('MOTIFS_DEPRECIATION_STOCK.DELETE.MESSAGE'),
				headerClass: 'modal-danger'
			});

			modalInstance.result.then(async function () {
				startLoading();
				try {
					await MotifsDepreciationStockService.deleteMotifDepreciationStockById(motifDepreciationStock.id);
					notification.success($translate.instant('MOTIFS_DEPRECIATION_STOCK.DELETE.SUCCESS'));

					selectedMotifDepreciationStockId = undefined;

					// si jamais la vue détail est affichée,
					// on va faire une rédirection vers la vue de la grille, adin de fermer la vue détail
					if (vm.stateParams.id) {
						$state.go('motifs-depreciation-stock.list');
					}

					loadMotifsDepreciationStock();
				} catch (ex) {
					notification.error(ex.data);
				} finally {
					stopLoading();
				}
			});
		}
	}

	function startLoading() {
		vm.loading = true;
	}

	function stopLoading() {
		vm.loading = false;
	}

	function dispose() {
		watchers.forEach((x) => x());
	}
}
